import { orderBy, where } from "firebase/firestore";
import useColection from "../colection";

import moment from "moment";
const usePrices = () => {
  const { uploadPhoto, savePhotoUrl, get, ...others } =
    useColection<Prices>("prices");
  const getByCompany = async (companyId: string) => {
    const resp = await get([where("companyId", "==", companyId)]);

    const format = (date: Date) => {
      const { seconds, nanoseconds } = date as unknown as {
        seconds: number;
        nanoseconds: number;
      };
      const auxi = moment
        .unix(seconds)
        .add(nanoseconds / 1000000, "milliseconds");
      return auxi;
    };

    resp.sort((a, b) => format(b.updatedAt).diff(format(a.updatedAt)));

    return Promise.resolve(resp);
  };

  return { ...others, get: getByCompany };
};

export default usePrices;
